export const mutations = {
  setProcoreAccountsList(state, payload) {
    state.procoreAccountsList = payload;
  },
  setShowProcoreModal(state, payload) {
    state.showExportToProcoreModal = payload;
  },
};
